import {AxiosError} from 'axios';
import {POST_ACCESS_ARRANGEMENT_AMENDMENT} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAccessArrangementAmendment = ({onSuccess, onError}: Input) => {
  const postAccessArrangementAmendment = async (uuid: string) => {
    await axiosClient.post(POST_ACCESS_ARRANGEMENT_AMENDMENT(uuid));
  };

  return useCustomMutation(postAccessArrangementAmendment, {
    onSuccess,
    onError,
  });
};
